import { FilledInput, FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Label } from '../lib/Label';

export const StyledFormControl = styled(FormControl)(() => ({
  fontSize: '16px',
}));

export const StyledLabel = styled(Label)(({ theme }) => ({
  marginLeft: '40px',
  transform: 'translate(12px, 15px) scale(1)',
  color: theme.palette.custom.black[30],
  fontWeight: 400,

  '&.Mui-focused': {
    color: theme.palette.custom.black[30],
    transform: 'translate(12px, 8px) scale(0.75)',
  },

  '&.MuiInputLabel-shrink': {
    transform: 'translate(12px, 8px) scale(0.75)',
  },

  '&.Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const StyledFilledInput = styled(FilledInput)(
  ({ theme, value, size }) => ({
    ...(size === 'medium' && {
      height: '52px',

      '&.MuiInputBase-root .MuiFilledInput-input': {
        paddingTop: '22px',
        paddingBottom: '5px',
        paddingLeft: '5px',
        paddingRight: '5px',
        borderRadius: '0px',
      },
    }),

    color: theme.palette.custom.black[90],
    lineHeight: '100%',
    border: `1px solid ${theme.palette.custom.black[!value ? 10 : 90]}`,
    borderRadius: '14px',
    backgroundColor: 'transparent',

    '&::before, &::after': {
      display: 'none',
    },

    '& .MuiInputAdornment-root:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: '0px !important',
    },

    '& .MuiInputAdornment-positionEnd': {
      color: theme.palette.custom.black[100],
    },

    '& .MuiFilledInput-input': {
      paddingLeft: '0px',
    },

    '&.Mui-focused': {
      backgroundColor: 'transparent',
    },

    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.custom.black[30],
      opacity: 1,
    },

    '&:hover:not(.Mui-disabled)': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.custom.black[30],
    },

    '&.Mui-error': {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,

      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.error.main,
      },
    },

    '&.Mui-disabled': {
      borderRadius: '14px',
      backgroundColor: theme.palette.custom.grey3,
      borderColor: theme.palette.custom.black[20],
    },
  })
);
